export default __webpack_public_path__ + "static/media/features-small.cdad2744.svg";